    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
        <h4 id="labelButtons">Customer Details</h4>
    </div>
    <ng-container *ngIf="!success">
        <div class="modal-body">
            <fieldset>
                <div class="row">
                    <div class="col-sm-4 col-md-3 mvd_form-group">
                        <label>Type</label>
                        <input type="text" class="mvd_form-control" [(ngModel)]="type" [ngModelOptions]="{standalone: true}" disabled />
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>Customer Number</label>
                        <input type="text" class="mvd_form-control" [(ngModel)]="customerNumberId" [ngModelOptions]="{standalone: true}" disabled />
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>EIN</label>
                        <input type="text" class="mvd_form-control" [(ngModel)]="ein" [ngModelOptions]="{standalone: true}" disabled />
                    </div>
                    <div class="col-sm-8 col-md-3 col-lg-4 mvd_form-group">
                        <label>Organization Type</label>
                        <select class="mvd_form-control" [(ngModel)]="organizationTypeId" [ngModelOptions]="{standalone: true}">
                            <option></option>
                            <option *ngFor="let organizationType of organizationTypeList" value="{{organizationType.id}}">{{organizationType.displayValue}}</option>
                        </select>
                    </div>
				    <div *ngIf="canEdit" class="col-sm-3 col-md-2 col-lg-1 mvd_form-group">
					    <label for="doNotUse">Do Not Use</label>
					    <input type="checkbox" class="mvd_form-control" [(ngModel)]="doNotUse" [ngModelOptions]="{standalone: true}">
				    </div>
				</div>
            </fieldset>
        </div>
        <div class="modal-footer">
            <div class="btn--group">
                <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
                <button class="btn--accent" type="submit" (click)="save()">Save</button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="success">
        <div class="modal-body">
            <span class="mvd_alert--message__info">
                The organization type has been successfully updated.
            </span>
        </div>

        <div class="modal-footer">
            <div class="btn--group">
                <button class="btn--primary" type="button" (click)="successfulCancel()">Close</button>
            </div>
        </div>
    </ng-container>